export default __webpack_public_path__ + "static/media/homebackground.fbb39dea.png";